import useAirlytics from "./useAirlytics";

export function AirlyticsConnector() {
  useAirlytics();
  return null;
}
